const PRODUCT_BASIC = 'productBasic';
const PRODUCT_BASIC_REDUCED = 'productBasicReduced';
const VARIATIONS = {
    VARIATION_1: '',
    VARIATION_2: '2',
    VARIATION_3: '3',
    VARIATION_4: '4',
    VARIATION_5: '5',
};

const LIGHTBOX_TRACK_LABELS = {
    widget_appears: {
        LOGGED: 'prime_mem_view_log-no-sub',
        PREMIUM: 'prime_mem_view_sub-no-log',
        REGISTERED: 'prime_mem_view_no-log-no-sub-upg',
        NOT_REGISTERED: 'prime_mem_view_no-log-no-sub_pax',
    },
    click_member: {
        LOGGED: 'prime_mem_select_log-no-sub',
        PREMIUM: 'prime_mem_select-sub-no-log',
        REGISTERED: 'prime_mem_select_no-log-no-sub-upg',
        NOT_REGISTERED: 'prime_mem_select_no-log-no-sub_pax',
    },
    password_error: {
        REGISTERED: 'pw_inline_FE_error_no-log-no-sub-upg',
        NOT_REGISTERED: 'pw_inline_FE_error_no-log-no-sub',
    },
};

module.exports = {
    PRODUCT_BASIC,
    PRODUCT_BASIC_REDUCED,
    LIGHTBOX_TRACK_LABELS,
    VARIATIONS,
};
